<p-confirmDialog header="Confirmation" [closable]="false">
</p-confirmDialog>